export interface ITemplatesState {
	channelFilter: Array<string>,
	languageFilter: Array<string>,
	toneOfVoiceFilter: Array<string>,
}

const state: ITemplatesState = {
	channelFilter: ['SMS', 'EMAIL', 'PHONE', 'MAIL', 'NONE'],
	languageFilter: [],
	toneOfVoiceFilter: ['FRIENDLY']
};

const mutations = {
	SET_CHANNEL_FILTER: (state, data) => {
		state.channelFilter = data;
	},
	SET_LANGUAGE_FILTER: (state, data) => {
		state.languageFilter = data;
	},
	SET_TONE_OF_VOICE_FILTER: (state, data) => {
		state.toneOfVoiceFilter = data;
	}
};

export default {
	namespaced: true,
	state,
	mutations
};
